import Highcharts from 'highcharts'
import moment from 'moment'
import indicadoresParams from '../../utils/indicadores-default-params'

const months = moment.localeData('es').months().map(m => m.toLowerCase())
// const weekdays = moment.localeData('es').weekdays().map(w => w.toLowerCase())
const trims = ['primavera', 'verano', 'otoño', 'invierno']

const trimsDates = {
  // trimestre: [mes, dia]
  "primavera": [2, 21],
  "verano": [5, 21],
  "otoño": [8, 23],
  "invierno": [11, 21]
}

const regexMonth = new RegExp(`(${months.join('|')})`)
const regexTrim = new RegExp(`(${trims.join('|')})`)
const regexYear = /\d{4}/

const intervals = {
  'Anual': 365 * 24 * 3600 * 1000,
  'Mensual': 30 * 24 * 3600 * 1000,
  'Trimestral': 30 * 24 * 3600 * 1000,
}

/**
 * Función para obtener la configuración del chart
 * @param {*} data: Resultados de la consulta de búsqueda
 * @param {*} indicadorName: Nombre del indicador de los datos
 * @param {*} period: Período de la aplicación
 * @param {*} isDarkTheme: tema de colores (Dark o Light)
 * @param {*} onSelect: Callback para cuando se pase el puntero por encima de la gráfica
 */
export default function(data, indicadorName, period, isDarkTheme, onSelect) {
  // console.log('this refers now to chart-search vue component', this)
  const translate = this.$t

  const unidades = indicadoresParams[indicadorName]['unidades']
  let dataFormatted = null

  switch(period) {
    case 'Anual': dataFormatted = data.map(([layerName, value]) => {
      const [year] = layerName.match(regexYear)
      const date = Date.UTC(year, 0, 1)
      return [date, value]
    }); break;

    case 'Mensual': dataFormatted = data.map(([layerName, value]) => {
      const [year] = layerName.match(regexYear).map(Number)
      const [month] = layerName.match(regexMonth)
      const date = Date.UTC(year, months.findIndex(m => m == month), 1)
      return [date, value]
    }); break;

    case 'Trimestral': dataFormatted = data.map(([layerName, value]) => {
      const [year] = layerName.match(regexYear).map(Number)
      const [trimName] = layerName.match(regexTrim)
      const [month, day] = trimsDates[trimName]
      const date = Date.UTC(year, month, day)

      return [date, value]
    }); break;

  }

  const meanFormatted = dataFormatted.map(([date, value], idx) => [date, data[idx][2]])

  return {

    exporting: {
      enabled: false,
    },

    chart: {
      type: 'spline',
      zoomType: 'x',
      style: {
        fontFamily: 'roboto, arial'
      }
    },

    title: {
      text: false
    },

    subtitle: {
      text: false
    },

    xAxis: {
      title: {
        text: translate('fecha')
      },
      type: 'datetime',
      tickInterval: intervals[period],
      dateTimeLabelFormats: {
        year: '%Y'
      }
    },

    yAxis: {
      title: {
        text: `${localize(translate(`indicadores.${indicadorName}`))} ${unidades ? `(${unidades})` : ''}`
      }
    },

    tooltip: {
      formatter() {
        const date = Highcharts.dateFormat(period == 'Anual' ? '%Y' : '%B %Y', new Date(this.x))
        const difference = this.points[0].y - this.points[1].y

        let s = `<b>${date}</b>`

        this.points.forEach(point => {
          s += `<br/><span style="color:${point.color}">\u25CF</span> <span style="color: ${point.color}">${point.series.name}</span>: <b>${point.y}</b>`
        })
        
        s += `<br/><span style="color: grey">\u25CF</span> <span style="color: grey">${translate('diferencia')}</span>: <b>${difference.toFixed(2)}</b>`

        return s
      },
      shared: true,
    },

    legend: {
      layout: 'vertical',
      align: 'center',
      verticalAlign: 'top',
      floating: true,
      backgroundColor: isDarkTheme ? '#000000' : '#FFFFFF',
      borderWidth: 2
    },

    plotOptions: {
      spline: {
        marker: {
          enabled: true
        }
      },

      series: {
        point: {
          events: {
            mouseOver(/*event*/) {
              const d = this.x
              const date = new Date(d)
              const layerName = dateToLayerName(date, indicadorName, period)
              onSelect.call(null, layerName)
            },

          }
        }
      }
    },

    series: [{
      name: `${localize(translate(`indicadores.${indicadorName}`))} (${translate('consulta')})`,
      data: dataFormatted,
      color: '#ffeb3b'
    }, {
      name: `${localize(translate(`indicadores.${indicadorName}`))} (${translate('extension')})`,
      data: meanFormatted,
      color: '#388e3c'
    }]

  }
}

function localize(word) {
  return word.charAt(0).toUpperCase() + word.slice(1).toLowerCase()
}

function dateToLayerName(date, indicador, period) {
  const year = date.getFullYear(),
        month = date.getMonth(),
        day = date.getDate()
  
  let layerName = `${indicador}_${period.toLowerCase()}`

  switch(period) {
    case 'Anual': return `${layerName}_${year}`;
    case 'Mensual': return `${layerName}_${months[month]}_${year}`;
    case 'Trimestral': 
      const trimestre = Object.entries(trimsDates).find(([k, [m, d]]) => m == month && day == d)[0]
      return `${layerName}_${trimestre}_${year}`;
  }
}


// WEBPACK FOOTER //
// ./src/components/core/search/charts/index.js